import { useQuery } from '@tanstack/react-query';
import { T } from 'gt-react';
import { CircleNotchIcon } from '@phosphor-icons/react';
import { useDocumentPreview } from '@/api/rpc/hooks/core/useDocuments';

export function PricelistCasePlainTextPreview({
  documentId,
}: {
  documentId: string;
}) {
  const { data, isLoading, error } = useDocumentPreview(documentId);
  const signedUrl = data?.signedUrl;
  const textQuery = useQuery({
    queryKey: ['pricelist-case-plain-text', signedUrl],
    queryFn: async ({ signal }) => {
      if (!signedUrl) throw new Error('preview failed');
      const response = await fetch(signedUrl, { signal });
      if (!response.ok) throw new Error('preview failed');
      return response.text();
    },
    enabled: Boolean(signedUrl),
    retry: false,
  });

  if (isLoading || (signedUrl && textQuery.isPending)) {
    return (
      <div className="flex h-full items-center justify-center">
        <CircleNotchIcon className="h-8 w-8 animate-spin text-muted-foreground" />
      </div>
    );
  }

  if (error || !signedUrl || textQuery.isError) {
    return (
      <div className="flex h-full items-center justify-center text-sm text-muted-foreground">
        <T context="document preview unavailable">No preview available</T>
      </div>
    );
  }

  return (
    <pre className="h-full overflow-auto whitespace-pre-wrap break-all p-4 font-mono text-sm">
      {textQuery.data}
    </pre>
  );
}
